﻿import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { OnePagePolicyReport } from '../../../api/reports';
import { useQuery } from '@tanstack/react-query';
import PowerBi from '../powerBi/powerBi';
import { useUser } from 'context/UserContext';
import { useNavigate, useLocation, createSearchParams } from 'react-router-dom';

export function ReportLoader(props) {
  const user = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  // The legacy one pager is not available to ISD accounts.
  const isdBlocked = props.view === 'OnePagerLegacy' && user?.division?.toUpperCase() === 'ISD';

  useEffect(() => {
    if (isdBlocked) {
      navigate(
        {
          pathname: '/Error/AccessDenied',
          search: `?${createSearchParams({ requested: location.pathname })}`,
        },
        { replace: true }
      );
    }
  }, [isdBlocked, location.pathname, navigate]);

  const [reportOutput, setReportOutput] = useState(null);
  const [onePagerPolicyID, setOnePagerPolicyID] = useState(null);
  const onePagePolicy = useQuery({
    queryKey: ['onePagePolicy', onePagerPolicyID],
    queryFn: () => OnePagePolicyReport({ PolicyID: onePagerPolicyID })(),
    enabled: false,
  });

  useEffect(() => {
    if (onePagePolicy.isSuccess && onePagePolicy.data) {
      setReportOutput(onePagePolicy.data);
    }
  }, [onePagePolicy.isSuccess, onePagePolicy.data]);

  const ExecuteOnePager = () => {
    onePagePolicy.refetch();
    /* const options = {
      crossDomain: true,
      method: 'GET',
    };
    fetch(`/Reports/OnePagePolicyReport?policyid=${onePagerPolicyID}`, options).then((res) => res.text()).then((result) => {
      setReportOutput(result);
    });*/
  };
  const createOnePager = () => ({ __html: reportOutput });
  const PrintElem = (id) => {
    const divToPrint = document.getElementById(id);
    if (divToPrint) {
      const newWin = window.open('', 'Print-Window');
      newWin.document.open();
      newWin.document.write(
        `<html><body onload="window.print()" style="display: block; font-family: monospace; white-space: pre; margin: 1em 0px; line-height: .6em;">${divToPrint.innerHTML}</body></html>`
      );
      newWin.document.close();
      setTimeout(() => {
        newWin.close();
      }, 10);
    }
  };
  return (
    <>
      {props.view === 'OnePagerLegacy' && !isdBlocked && (
        <div className="container">
          <div className="row mt-4">
            <div className="col-3 d-flex justify-content-start align-items-center">
              <input
                onBlur={(e) => {
                  setOnePagerPolicyID(e.target.value);
                }}
                style={{ height: '2.5em' }}
                className="form-control form-control-sm ml-3 w-75"
                type="text"
                placeholder="Policy Number"
                aria-label="Search"
              />
            </div>
            <div className="col-1 justify-content-start align-items-center">
              <Button
                onClick={() => {
                  ExecuteOnePager();
                }}
                variant="contained"
                className="btn btn-primary"
              >
                View
              </Button>
            </div>
            {reportOutput && (
              <div className="col-1 justify-content-start align-items-center">
                <Button
                  id="btnPrintReport"
                  variant="contained"
                  className="btn btn-secondary"
                  onClick={() => PrintElem('ShowReport')}
                >
                  Print
                </Button>
              </div>
            )}
          </div>
          <div className="rowt mt-4">
            <div className="col-12" dangerouslySetInnerHTML={createOnePager()} />
          </div>
        </div>
      )}
      {props.view === 'OnePager' && (
        <PowerBi
          npnUpdateDetails={props.npnUpdateDetails}
          params={props.params}
          workspaceId={props.powerBIWorkspaceID}
          reportId={props.powerBIReportID}
          groupId={props.powerBIGroupID}
          datasetId={props.powerBIDatasetID}
        />
      )}
      {props.view !== 'OnePager' && props.view !== 'OnePagerLegacy' && <div>Report Not Found</div>}
    </>
  );
}
